import React, { useState } from "react";
import styled from "styled-components";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import NumberInput from "../../components/Input/NumberInput";
import Button from "../../components/Button/Button";
import { AttributesType, IProject } from "../../reducers/project";
import { useDispatch, useSelector } from "react-redux";
import changeProjectCount from "../../actions/project/changeProjectCount";
import deleteCart from "../../actions/project/deleteCart";
import { Link } from "react-router-dom";
import content from "../../content";
import useDesktop from "../../components/Responsive/useDesktop";
import Desktop from "../../components/Responsive/Desktop";
import { getLoading } from "../../reducers/project/selectors";
import Scrollbars from "react-custom-scrollbars";

const Wrapper = styled.div<{ open: boolean; desktop: boolean }>`
  width: 100%;
  min-height: 60px;
  max-height: ${(props) => (props.open ? "460px" : "60px")};
  height: ${(props) => (props.open ? "auto" : "60px")};
  margin-bottom: 8px;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  padding: 16px ${({ desktop }) => (desktop ? "32" : "16")}px 16px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #e1e1e1;
  background-color: white;
  user-select: none;
  border-radius: 4px;
`;

const Label = styled.div<{ desktop: boolean }>`
  font-weight: 500;
  z-index: 1;
  font-family: Inter;
  font-size: ${({ desktop }) => (desktop ? "14" : "12")}px;
  color: #1e2029;
  overflow: ${({ desktop }) => (desktop ? "unset" : "hidden")};
  max-height: ${({ desktop }) => (desktop ? "unset" : "20px")};
`;

const PriceLabel = styled.div<{ color?: any; desktop: boolean }>`
  display: flex;
  font-family: Inter;
  align-items: ${({ desktop }) => (desktop ? "center" : "unset")};
  font-weight: bold;
  font-size: 16px;
  overflow: ${({ desktop }) => (desktop ? "unset" : "hidden")};
  max-height: ${({ desktop }) => (desktop ? "unset" : "20px")};
  color: ${({ color }) => (color ? "#1B576A" : "#1B576A")};
  letter-spacing: -0.01em;
  z-index: 200;
`;

const Grid = styled.div<{ desktop?: boolean }>`
  display: grid;
  grid-template-columns: ${({ desktop }) =>
          desktop ? "minmax(82%, 400px)" : "30vw"} ${({ desktop }) =>
          desktop ? "minmax(100px, 1fr)" : "100px"};
  font-size: ${({ desktop }) => (desktop ? "14" : "12")}px;
`;

export const projectLabel = (project: IProject) => {
    if (project === undefined) {
        return "";
    }
    const color = project.components.find(
        (c) => c.category === AttributesType.Color
    )?.name;
    const side = project.components.find(
        (c) => c.category === AttributesType.OpenDirection
    )?.name;
    const handle = project.components.find(
        (c) => c.category === AttributesType.Handle
    )?.name;
    const ferrule = project.components.find(
        (c) => c.category === AttributesType.Ferrule
    )?.name;

    return `${content.getValue(color)} ${content.getValue(
        side
    )}, ${content.getValue(handle)} ${content.getValue(ferrule)}`;
};

const ExpandLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: -0.01em;

  color: #7a7c8b;

  opacity: 0.6;
`;

function ProjectExpander({ history, project }: IProjectExpander) {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector(getLoading);

    const projectCount = project.count;

    const desktop = useDesktop();

    const onCountChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
        if (Number(e.currentTarget.value) > 0 && !loading) {
            dispatch(changeProjectCount(project.id, Number(e.currentTarget.value)));
        }
    };

    const cartDelete = (id: string) => () => dispatch(deleteCart(id));
    const copyProject = () =>
        navigator.clipboard.writeText(`${window.location.origin}/${project.id}`);

    return (
        <Wrapper desktop={desktop} open={open} onClick={() => setOpen(!open)}>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        width: desktop ? "calc(100% - 67px)" : "100%",
                        margin: desktop ? "-17px 0px" : "-17px 0px 0px -12px",
                        background: open ? "white" : "unset",
                        borderBottom: "1px solid #E1E1E1",
                        boxSizing: "border-box",
                        height: "60px",
                    }}
                ></div>
                <div
                    style={{
                        height: "100%",
                        justifyContent: "space-between",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Label desktop={desktop}>{projectLabel(project)}</Label>
                    {open && (
                        <Scrollbars
                            style={{
                                margin: "25px 0px 10px",
                            }}
                            autoHeight={true}
                            autoHeightMax={"402px"}
                        >
                            <Grid desktop={desktop}>
                                {project.components.map((s) => (
                                    <>
                                        <div
                                            style={{
                                                padding: desktop ? "10px 0px" : "8px 0px",
                                                fontFamily: "Inter",
                                                fontStyle: "normal",
                                                fontWeight: 600,
                                                color: "#7A7C8B",
                                                letterSpacing: "-0.01em",
                                                fontSize: desktop ? "14px" : "12px",
                                                lineHeight: "14px",
                                            }}
                                        >
                                            {content.getValue(s?.name)}
                                        </div>
                                        <div
                                            style={{
                                                padding: desktop ? "10px 0px" : "8px 0px",
                                                fontFamily: "Inter",
                                                fontStyle: "normal",
                                                fontWeight: 600,
                                                letterSpacing: "-0.01em",
                                                color: "#1B576A",
                                                lineHeight: "14px",
                                            }}
                                        >
                                            {s?.price} {content.getValue("currency")}
                                        </div>
                                    </>
                                ))}
                            </Grid>
                        </Scrollbars>
                    )}
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                        }}
                    >
                        {!history && open && desktop ? (
                            <NumberInput
                                wrapperStyle={{
                                    position: "absolute",
                                    marginTop: "-6px",
                                    transform: desktop ? "translateX(-50%)" : "translateX(-10%)",
                                    zIndex: 1000,
                                }}
                                style={{
                                    width: "150px",
                                }}
                                placeholder={content.getValue("many")}
                                value={projectCount}
                                onChange={onCountChange}
                            />
                        ) : (
                            <></>
                        )}
                        <Desktop>
                            <div style={{ width: "50px" }}></div>
                        </Desktop>

                        {(!open || desktop) && (
                            <PriceLabel
                                desktop={desktop}
                                style={{
                                    width: desktop ? "250px" : "unset",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginRight: desktop ? "30px" : "10px",
                                    fontSize: desktop ? "16px" : "14px",
                                }}
                            >
                                {project.components.length === 0
                                    ? 0
                                    : project.components.reduce(
                                        (a, b) =>
                                            (Number(a) + Number(b?.price) * project.count).toFixed(
                                                2
                                            ),
                                        ""
                                    )}{" "}
                                {content.getValue("price_surfix")}
                            </PriceLabel>
                        )}
                        {open ? (
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <ExpandLabel>{content.getValue("less")}</ExpandLabel>
                                <KeyboardArrowDown
                                    style={{
                                        fontSize: "18px",
                                        color: "black",
                                        zIndex: 1,
                                    }}
                                />
                            </div>
                        ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <ExpandLabel>{content.getValue("more")}</ExpandLabel>
                                <KeyboardArrowUp
                                    style={{
                                        fontSize: "18px",
                                        color: "black",
                                        zIndex: 1,
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    {open && (
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "flex",
                                marginTop: "30px",
                                justifyContent: desktop ? "flex-end" : "unset",
                                flexDirection: desktop ? "row" : "column",
                            }}
                        >
                            <div style={{ display: "flex" }}>
                                <Link to={`/${project.id}`}>
                                    <Button
                                        reverse={true}
                                        style={{
                                            borderRadius: 0,
                                            height: "45px",
                                            width: "100%",
                                            backgroundColor: "#F9F9F9",
                                            marginBottom: desktop ? "0" : "10px",
                                        }}
                                        variant={"text"}
                                        Icon={
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M8.84573 3.08379L12.1343 6.43105C12.2728 6.57207 12.2728 6.80215 12.1343 6.94316L4.17177 15.0479L0.788435 15.4301C0.336352 15.482 -0.0464609 15.0924 0.00458078 14.6322L0.380101 11.1885L8.3426 3.08379C8.48114 2.94277 8.70718 2.94277 8.84573 3.08379ZM14.752 2.23398L12.9728 0.423047C12.4186 -0.141016 11.5181 -0.141016 10.9603 0.423047L9.66968 1.73672C9.53114 1.87773 9.53114 2.10781 9.66968 2.24883L12.9582 5.59609C13.0968 5.73711 13.3228 5.73711 13.4614 5.59609L14.752 4.28242C15.3061 3.71465 15.3061 2.79805 14.752 2.23398Z"
                                                    fill="#EFA21E"
                                                />
                                            </svg>
                                        }
                                        label={content.getValue("button_edit")}
                                    />
                                </Link>
                            </div>
                            {!history && <div style={{ width: "15px" }}></div>}
                            {!history && (
                                <div style={{ display: "flex" }}>
                                    <div>
                                        <Button
                                            style={{
                                                borderRadius: 0,
                                                height: "45px",
                                                width: "100%",
                                                backgroundColor: "#F9F9F9",
                                            }}
                                            reverse={true}
                                            onClick={cartDelete(project.id)}
                                            variant={"text"}
                                            Icon={
                                                <svg
                                                    width="14"
                                                    height="17"
                                                    viewBox="0 0 14 17"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M13 15.4063C13 15.8289 12.842 16.2343 12.5607 16.5332C12.2794 16.8321 11.8978 17 11.5 17H2.5C2.10218 17 1.72064 16.8321 1.43934 16.5332C1.15804 16.2343 1 15.8289 1 15.4063V4.25H13V15.4063ZM4.5 6.90625C4.5 6.76536 4.44732 6.63023 4.35355 6.5306C4.25979 6.43097 4.13261 6.375 4 6.375C3.86739 6.375 3.74021 6.43097 3.64645 6.5306C3.55268 6.63023 3.5 6.76536 3.5 6.90625V14.3438C3.5 14.4846 3.55268 14.6198 3.64645 14.7194C3.74021 14.819 3.86739 14.875 4 14.875C4.13261 14.875 4.25979 14.819 4.35355 14.7194C4.44732 14.6198 4.5 14.4846 4.5 14.3438V6.90625ZM7.5 6.90625C7.5 6.76536 7.44732 6.63023 7.35355 6.5306C7.25979 6.43097 7.13261 6.375 7 6.375C6.86739 6.375 6.74021 6.43097 6.64645 6.5306C6.55268 6.63023 6.5 6.76536 6.5 6.90625V14.3438C6.5 14.4846 6.55268 14.6198 6.64645 14.7194C6.74021 14.819 6.86739 14.875 7 14.875C7.13261 14.875 7.25979 14.819 7.35355 14.7194C7.44732 14.6198 7.5 14.4846 7.5 14.3438V6.90625ZM10.5 6.90625C10.5 6.76536 10.4473 6.63023 10.3536 6.5306C10.2598 6.43097 10.1326 6.375 10 6.375C9.86739 6.375 9.74021 6.43097 9.64645 6.5306C9.55268 6.63023 9.5 6.76536 9.5 6.90625V14.3438C9.5 14.4846 9.55268 14.6198 9.64645 14.7194C9.74021 14.819 9.86739 14.875 10 14.875C10.1326 14.875 10.2598 14.819 10.3536 14.7194C10.4473 14.6198 10.5 14.4846 10.5 14.3438V6.90625ZM0.5 1.06251H4.25L4.54375 0.441607C4.60598 0.308866 4.70183 0.197207 4.82053 0.119191C4.93922 0.0411758 5.07605 -0.000100538 5.21562 5.82141e-06H8.7875C8.92676 -0.000562966 9.06335 0.0405594 9.18162 0.118662C9.2999 0.196764 9.39508 0.308687 9.45625 0.441607L9.75 1.06251H13.5C13.6326 1.06251 13.7598 1.11848 13.8536 1.2181C13.9473 1.31773 14 1.45286 14 1.59376V2.65626C14 2.79715 13.9473 2.93228 13.8536 3.03191C13.7598 3.13153 13.6326 3.1875 13.5 3.1875H0.5C0.367392 3.1875 0.240214 3.13153 0.146446 3.03191C0.0526781 2.93228 0 2.79715 0 2.65626V1.59376C0 1.45286 0.0526781 1.31773 0.146446 1.2181C0.240214 1.11848 0.367392 1.06251 0.5 1.06251Z"
                                                        fill="#EFA21E"
                                                    />
                                                </svg>
                                            }
                                            label={content.getValue("button_delete")}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Wrapper>
    );
}

export interface IProjectExpander {
    history?: boolean;
    project: IProject;
}

export default ProjectExpander;
